import { ConditionTypeConfig, WaitingRoomConditionType } from "./types";

export const SignedDocumentConditionType =
  WaitingRoomConditionType.SIGNED_DOCUMENT_REQUIRED;

export const PendingConditionTypes = [
  WaitingRoomConditionType.ACTIVE_FORM,
  WaitingRoomConditionType.EMPLOYEE_REQUIRED,
  WaitingRoomConditionType.PARENT_REQUIRED_AUTO,
  WaitingRoomConditionType.WAITING_FOR_PARENT,
];

export const conditionTypes: Record<
  WaitingRoomConditionType,
  ConditionTypeConfig
> = {
  [WaitingRoomConditionType.AHR_ACCEPTANCE_REQUIRED]: {
    label: "Akceptacja AHR",
    acceptedLabel: "Akceptacja AHR",
  },
  [WaitingRoomConditionType.ACCEPT_ONLY]: {
    label: "Akceptacja AHR",
    acceptedLabel: "Akceptacja AHR",
  },
  [WaitingRoomConditionType.ACTIVE_FORM]: {
    label: "Oczekuje na uzupełnienie danych",
    acceptedLabel: "Dane uzupełnione",
  },
  [WaitingRoomConditionType.BARCODE]: {
    label: "Dokument",
    acceptedLabel: "Dokument",
  },
  [WaitingRoomConditionType.EMPLOYEE_REQUIRED]: {
    label: "Oczekuje na osobę główną",
    acceptedLabel: "Osoba główna",
  },
  [WaitingRoomConditionType.FINANCING_CHANGE_REQUIRED]: {
    label: "Zmiana finansowania",
    acceptedLabel: "Zmiana finansowania",
  },
  [WaitingRoomConditionType.NEW_PRICE]: {
    label: "Zmiana finansowania",
    acceptedLabel: "Zmiana finansowania",
  },
  [WaitingRoomConditionType.PARENT_REQUIRED_AUTO]: {
    label: "Oczekuje na świadczenie główne",
    acceptedLabel: "Świadczenie główne",
  },
  [WaitingRoomConditionType.WAITING_FOR_PARENT]: {
    label: "Oczekuje na świadczenie główne",
    acceptedLabel: "Świadczenie główne",
  },
  [WaitingRoomConditionType.DOCUMENT_REQUIRED]: {
    label: "Akceptacja dokumentu potrącenia z wynagrodzenia",
    acceptedLabel: "Zgoda na potrącenie",
  },
  [WaitingRoomConditionType.SIGNED_DOCUMENT_REQUIRED]: {
    label: "Wymagany podpisany dokument e\u2011podpisem",
    acceptedLabel: "Podpisana zgoda na potrącenie",
  },
} as const;

export const getConditionLabel = (
  type: WaitingRoomConditionType,
  isAccepted: boolean
) => conditionTypes[type][isAccepted ? "acceptedLabel" : "label"] || type;

export const salaryDeductionActionOption = {
  label: "Akceptacja zgody na potrącenie",
  value: "SALARY_DEDUCTION",
};

export const conditionTypesActionOptions = [
  {
    label: "Akceptacja AHR",
    value: [
      WaitingRoomConditionType.ACCEPT_ONLY,
      WaitingRoomConditionType.AHR_ACCEPTANCE_REQUIRED,
    ],
  },
  {
    label: "Akceptacja zmiany finansowania",
    value: [
      WaitingRoomConditionType.FINANCING_CHANGE_REQUIRED,
      WaitingRoomConditionType.NEW_PRICE,
    ],
  },
];

export const conditionTypesFilterOptions = [
  {
    label: "Do akceptacji AHR",
    value: [
      WaitingRoomConditionType.ACCEPT_ONLY,
      WaitingRoomConditionType.AHR_ACCEPTANCE_REQUIRED,
    ],
  },
  {
    label: "Do akceptacji zgoda na potrącenie",
    value: [
      "DEDUCTION_CONSENT",
      WaitingRoomConditionType.DOCUMENT_REQUIRED,
      WaitingRoomConditionType.SIGNED_DOCUMENT_REQUIRED,
    ],
  },
  {
    label: "Do akceptacji zmiana finansowania",
    value: [
      WaitingRoomConditionType.FINANCING_CHANGE_REQUIRED,
      WaitingRoomConditionType.NEW_PRICE,
    ],
  },
  {
    label: "Oczekuje na osobę główną",
    value: WaitingRoomConditionType.EMPLOYEE_REQUIRED,
  },
  {
    label: "Oczekuje na świadczenie główne",
    value: [
      WaitingRoomConditionType.PARENT_REQUIRED_AUTO,
      WaitingRoomConditionType.WAITING_FOR_PARENT,
    ],
  },
  {
    label: "Oczekuje na uzupełnienie danych",
    value: WaitingRoomConditionType.ACTIVE_FORM,
  },
];

export const SELECTED_ROW_CLASS = "pending-benefits--selected";
